import {
    useState,
    useEffect,
    useContext,
    CSSProperties,
} from "react";
import { CampaignDetails, EmailCampaignData } from "modules/Types";
import Fanbase from "./Components/Fanbase";
import {
    DefaultImage,
    UnlockBannerContainer,
} from "./styles";
import { getFansMetrics_api, getDownloadSignedUrl_api, getImportingNewFansStatus_api, getEmailCampaigns_api } from "api/brandApi";
import { FansMetrics1 } from 'modules/Types';
import FanCardMetrics from './Components/FanCardMetrics/FanCardMetrics';
import emptyUserPink from "assets/images/empty-user-pink.png";
import YellowStar from "assets/images/yellow-star.png";
import FansDetailsModal from './Components/FansDetailsModal/FansDetailsModal';
import { getStatusToShowPaymentFailedBanner, makeKey } from "modules/Utils";
import { UpgradeModalContext } from "Hooks/UpgradeModalContext";
import UnlockDataBanner from "components/shareable/UnlockDataBanner";
import UnlockDataImage from "assets/images/unlock-data-geographies.svg";
import { pageView, track } from "analytics";
import UpgradeToProChip from "components/shareable/UpgradeToProChip";
import Intercom from "helpers/Intercom";
import useBrand, { BrandExistsState } from 'Hooks/useBrand';
import useScreen from "Hooks/useScreen";
import useUser from "Hooks/useUser";
import { useHistory, useLocation } from "react-router-dom";
import Loader from "elements/Loader";
import AdminContainerForceForeverSaves from './Components/AdminContainerForceForeverSaves';
import ButtonSymphony from "elements/ButtonSymphony";
import PageSymphony from "elements/PageSymphony";
import TabSymphony from "elements/TabSymphony";
import CardSymphony from "elements/CardSymphony";
import TabsSymphony, { TabItem } from "elements/TabsSymphony";
import CampaignCardSymphony from "elements/CampaignInfoSymphony";
import Sty from "modules/Sty";
import Colors from "modules/Colors";
import ModalSymphony from "elements/ModalSymphony";
import Icon from "elements/Icon";
import InputSymphony from "elements/InputSymphony";
import FansTable from "./Components/FansTable/FansTable";
import useFans from "Hooks/useFans";

const POLL_INTERVAL = 10000; // 10 seconds 

const PAGE_SIZE = 25

enum Tabs {
    FANBASE = "Fanbase",
    CAMPAIGNS = "Campaigns",
}

const FANBASE_TABS = [
    {
        id: Tabs.FANBASE,
        title: Tabs.FANBASE,
    },
    // {
    //     id: Tabs.CAMPAIGNS,
    //     title: Tabs.CAMPAIGNS,
    // }
]

interface LocationState {
    importingFans?: boolean;
}

const Fans = () => {
    const history = useHistory();
    const location = useLocation();
    const { mobileView, mStyle } = useScreen();
    const {
        currentBrand,
        isProBrand,
        isLiteBrand,
        isBrandAdmin,
        getIsPaymentFailed
    } = useBrand() as BrandExistsState;
    const { isSymphonyAdmin } = useUser();
    const {
        searchFansInputValue,
        setSearchFansInputValue,
        sendFanSearchToMaestro,
        fansMaestroSearchResults,
        selectedFan,
        showFansDetailsModal,
        isLoadingMetrics,
        isLoadingImportStatus,
        setIsLoadingMetrics,
        setIsLoadingImportStatus,
        getFansData,
    } = useFans()
    const { handleOpenModal: handleOpenUpgradeToProModal } = useContext(UpgradeModalContext);
  

    const [emailCampaignsData, setEmailCampaignsData] = useState<EmailCampaignData[]>([]);
    const [showSearchFansAiModal, setShowSearchFansAiModal] = useState<boolean>(false);

    /** Get initial tab from URL query parameter, defaulting to FANBASE */
    const getInitialTab = () => {
        const params = new URLSearchParams(location.search);
        const tabParam = params.get('tab');
        return FANBASE_TABS.find(tab => tab.id === tabParam) || FANBASE_TABS[0];
    }

    const [selectedFansTab, setSelectedFansTab] = useState<TabItem>(getInitialTab());
    const [hasFans, setHasFans] = useState<boolean>(false);
    const [isDownloading, setIsDownloading] = useState<boolean>(false);
    const [fansMetrics, setFansMetrics] = useState<FansMetrics1>({
        fanbaseGrowth: "0.0",
        foreverPresaveFans: 0,
        foreverPresaveFansGrowth: "0.0",
        totalFanbase: 0,
    });

    const [isImporting, setIsImporting] = useState((history.location.state as LocationState)?.importingFans || false);

    const [showPaymentFailedModal, setShowPaymentFailedModal] = useState<boolean>(getIsPaymentFailed())

    const showPaymentFailedBanner = getStatusToShowPaymentFailedBanner(currentBrand)

    const getFanbaseMetrics = async (brandId: number) => {
        try {
            setIsLoadingMetrics(true)
            setHasFans(false)

            const { data, error } = await getFansMetrics_api(brandId);
            if (error) {
                throw new Error('Error getting fanbase metrics')
            }
            const formattedFansMetrics = data as unknown as FansMetrics1;
            setFansMetrics(formattedFansMetrics);
            setHasFans(formattedFansMetrics.totalFanbase > 0)
        } catch (error) {
            console.error('Error getting fanbase metrics:', error);
            setHasFans(false);
        } finally {
            setIsLoadingMetrics(false);
        }
    }

    const getEmailCampaigns = async (brandId: number) => {
        try {
            const data = await getEmailCampaigns_api(brandId);
            setEmailCampaignsData(data);
        } catch (error) {
            console.error('Error getting email campaigns:', error);
        }
    }

    useEffect(() => {
        pageView("Fans");

        // Start polling for import status
        const cleanup = startCheckingImportCompleted();

        return () => {
            cleanup();
        };
    }, [])

    useEffect(() => {
        if (!isLoadingMetrics) {
            getFanbaseMetrics(currentBrand.id)
        }

        getEmailCampaigns(currentBrand.id)
        getFansData({
            limit: PAGE_SIZE,
            offset: 0,
        })

        setShowPaymentFailedModal(getIsPaymentFailed())
    }, [currentBrand.id])

    const handleSearchMaestro = () => {
        sendFanSearchToMaestro()
    }

    const handleEmailFans = () => {
        console.log("Email Fans")
    }

    const handleSaveAudience = () => {
        console.log("Save Audience")
    }

    const handleDownloadCsv = async () => {
        if (!isProBrand) {
            track("Tried Downloading Fans CSV")
            handleOpenUpgradeToProModal({
                source: "Fans Tab - CSV Download"
            });
            return;
        } else {
            track("Download Fans CSV")
        }

        setIsDownloading(true);

        // then download the csv
        const downloadUrl = await getDownloadSignedUrl_api(currentBrand.id);
        if (downloadUrl.data) {
            window.location.assign(downloadUrl.data);
        } else {
            Intercom.showNewMessage("I'd like to download my Fans CSV. Can you help me with that?")
        }
        setIsDownloading(false);
    }

    const handleFilter = () => {
        // TODO: Implement filter
        console.log("Filter")
    }

    const handleImport = () => {
        history.push("/import-fans");
    }

    const handleMessageFans = () => {
        history.push("/message-your-fans");
    }

    const handleSearchFans = () => {
        // history.push("/search-fans");
    }

    const startCheckingImportCompleted = () => {
        /** Check import status immediately */
        const checkImportStatus = async () => {
            try {
                setIsLoadingImportStatus(true);
                const res = await getImportingNewFansStatus_api(currentBrand.id);
                const {
                    data: importStatusData,
                    error: importStatusError
                } = res;

                if (importStatusError) {
                    return;
                }

                const importStatus = importStatusData?.status;
                setIsLoadingImportStatus(false);

                if (importStatus === 'processing') {
                    return;
                }

                setIsImporting(false);
                clearInterval(intervalId);
                await getFanbaseMetrics(currentBrand.id);
            } catch (error) {
                console.error('Error checking import status:', error);
            } finally {
                setIsLoadingImportStatus(false);
            }
        }

        // Run first check immediately
        checkImportStatus();

        // Then set up interval for subsequent checks
        const intervalId = setInterval(checkImportStatus, POLL_INTERVAL);

        // Clean up interval on component unmount
        return () => clearInterval(intervalId);
    }

    /** Update URL when tab changes */
    const handleTabChange = (tab: TabItem) => {
        const params = new URLSearchParams(location.search);
        params.set('tab', tab.id);
        history.replace({ search: params.toString() });
        setSelectedFansTab(tab as TabItem);
    }

    if (isLoadingImportStatus) {
        return (
            <Loader className="fansLoader" size={40} title="Loading Fans..." isCentered />
        )
    }

    const renderMessageYourFansButton = () => {
        return null 
        return (
            <ButtonSymphony
                className="messageFansButton"
                onClick={handleMessageFans}
            >
                Message your fans
            </ButtonSymphony>
        )
    }

    const renderFansMetrics = () => {
        return (
            <div
                className="cardMetricsContainer"
                style={mStyle(sty, 'cardMetricsContainer')}
            >
                <FanCardMetrics
                    icon="audiences"
                    percentage={fansMetrics.fanbaseGrowth}
                    title='Fans'
                    total={fansMetrics.totalFanbase}
                />
                <FanCardMetrics
                    icon="personCheck"
                    percentage={fansMetrics.foreverPresaveFansGrowth}
                    title={(
                        <div className="foreverSavesTitle" style={{ display: 'flex', flexDirection: 'row', gap: 4 }}>
                            Forever Saves <UpgradeToProChip className="cardMetricsForeverPresaveFansProChip" type="gem" color="purple" size={10} />
                        </div>
                    )}
                    total={fansMetrics.foreverPresaveFans}
                    elementKey='forever-presave-fans'
                />
            </div>
        )
    }

    const renderFansTabButtons = () => {
        return (
            <div
                className="fansTabButtonsContainer"
                style={mStyle(sty, 'fansTabButtonsContainer')}
            >
                {isDownloading ?
                    <Loader className="downloadCsvFansButton" />
                    :
                    isBrandAdmin &&
                    <>
                        {/* <FansActionButton text="Filter" onClick={handleFilter}/> */}
                        <ButtonSymphony
                            className="downloadCsvFansButton"
                            variant="text"
                            onClick={handleDownloadCsv}
                            size={mobileView ? 'small' : 'medium'}
                        >
                            Download CSV
                        </ButtonSymphony>
                        {/* <ButtonSymphony
                            className="importFansButton"
                            variant="text"
                            onClick={handleImport}
                            size={mobileView ? 'small' : 'medium'}
                        >
                            Import Fans
                        </ButtonSymphony> */}
                        {/* NOTE: Search Fans MaestroAiFans Conner
                        <ButtonSymphony
                            className="searchFansButton"
                            variant="text"
                            onClick={() => setShowSearchFansModal(true)}
                            size={mobileView ? 'small' : 'medium'}
                        >
                            Search
                        </ButtonSymphony> */}
                    </>
                }
            </div>
        )
    }

    const renderCampaigns = () => {
        if (emailCampaignsData.length === 0) {
            return (
                <div className="noCampaignsContainer" style={sty.noCampaignsContainer}>
                    <div style={Sty.text18}>
                        No campaigns found
                    </div>
                    <div style={{ ...Sty.text16grey, marginBottom: 16 }}>
                        Start building your fanbase by importing your email list or by adding fans manually.
                    </div>
                    {renderMessageYourFansButton()}
                </div>
            )
        }
        return emailCampaignsData.map((campaign, index) => {
            return (
                <CampaignCardSymphony
                    key={makeKey(campaign.id, index)}
                    className="campaignCardFans"
                    campaign={campaign as unknown as CampaignDetails}
                    onClick={() => history.push(`/fans/campaigns/${campaign.id}`)}
                // stats={email_fanbase}
                />
            )
        })
    }

    const renderFansTabContainer = () => {
        return (
            <CardSymphony className="fansTabContainer">
                <div
                    className="fansTabContainerInner"
                    style={mStyle(sty, 'fansTabContainerInner')}
                >
                    <TabsSymphony
                        className="fansTabSelector"
                        selectedTab={selectedFansTab}
                        tabs={FANBASE_TABS}
                        onChange={(tab: string | TabItem) => handleTabChange(tab as TabItem)}
                        rightSideContent={renderFansTabButtons()}
                    />
                </div>

                <TabSymphony
                    className="fanbaseTab"
                    visible={selectedFansTab.id === FANBASE_TABS[0].id}
                    style={{ paddingTop: 24 }}
                >
                    <Fanbase />
                </TabSymphony>

                <TabSymphony
                    className="campaignsTab"
                    visible={FANBASE_TABS[1] && selectedFansTab.id === FANBASE_TABS[1].id}
                >
                    {renderCampaigns()}
                </TabSymphony>
            </CardSymphony>
        )
    }

    const renderImportStatus = () => {
        return (
            <div className="importStatusContainer" style={sty.importStatusContainer}>
                <div className="importStatusIcon" style={sty.importStatusIcon}>
                    <Loader />
                </div>
                <CardSymphony
                    className="importStatusTitle"
                    title="Importing fans"
                    subtitle="We are importing your fanbase information. But don't worry, you can still use Symphony in the meantime."
                    size="small"
                    isNoPadding
                />
            </div>
        )
    }

    // NOTE: render()
    return (
        <>
            <PageSymphony
                className="fansComponent"
                isContent
            >
                <div className="fansInnerContainer" style={sty.fansInnerContainer}>

                    <CardSymphony
                        className="fansTitle"
                        title="Fans"
                        subtitle="Your fans, all in one place."
                    >
                        {renderMessageYourFansButton()}
                    </CardSymphony>
                    {isSymphonyAdmin && <AdminContainerForceForeverSaves />}
                    {renderFansMetrics()}

                    {!isProBrand && hasFans &&
                        <UnlockBannerContainer padding={mobileView ? "0 8px 0" : "0px"}>
                            <UnlockDataBanner
                                source="Fans Tab - Unlock Data"
                                title="Learn exactly who your fans are"
                                description="Go Pro to see your fans name + locations, down to the city"
                                image={UnlockDataImage}
                                hideImage={mobileView}
                                imageMaxWidth='230px'
                            />
                        </UnlockBannerContainer>
                    }

                    {isImporting &&
                        renderImportStatus()
                    }

                    {renderFansTabContainer()}
                </div>
            </PageSymphony>

            {/* MODALS */}
            {selectedFan && showFansDetailsModal &&
                <FansDetailsModal />
            }

            <ModalSymphony
                className="searchFansAiModal"
                title="Search Fans"
                isOpen={showSearchFansAiModal}
                onClose={() => setShowSearchFansAiModal(false)}
                size="large"
                style={{ gap: 16 }}
            >
                <div className="searchFansModalSubHeader" style={sty.searchFansModalSubHeader}>
                    <Icon
                        className="searchFansModalIcon"
                        icon="maestroBadgeImage"
                        size={48}
                    />
                    <div style={Sty.text16grey}>
                        Maestro AI
                    </div>
                </div>
                <InputSymphony
                    className="searchFansModalInput"
                    value={searchFansInputValue}
                    onChange={(value) => setSearchFansInputValue(value)}
                    placeholder="Which fans are you looking for?"
                    isSearch
                    onSearch={handleSearchMaestro}
                />
                {fansMaestroSearchResults.length > 0 &&
                    <div className="searchFansModalButtonsContainer" style={{ display: 'flex', gap: 16 }}>
                        <ButtonSymphony
                            className="searchFansModalButton"
                            onClick={handleEmailFans}
                            variant="text"
                        >
                            Email these fans
                        </ButtonSymphony>
                        <ButtonSymphony
                            className="searchFansModalButton"
                            onClick={handleSaveAudience}
                            variant="text"
                        >
                            Save Audience
                        </ButtonSymphony>
                    </div>
                }

                <FansTable
                    isMaestro
                />
            </ModalSymphony>
        </>
    );
};

const sty: Record<string, CSSProperties> = {
    fansInnerContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16
    },
    importFansButton: {
        marginLeft: 16
    },
    importStatusContainer: {
        backgroundColor: '#fdeedc',
        border: '1px solid #fdd2a8',
        borderRadius: 5,
        padding: 16,
        display: 'flex',
        alignItems: 'center',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
    },
    importStatusIcon: {
        width: 24,
        height: 24,
        backgroundColor: '#f5a623',
        borderRadius: '50%',
        marginRight: 16
    },
    importStatusTitle: {
        fontWeight: 500
    },
    importStatusDescription: {
        margin: '4px 0 0',
        fontSize: 14
    },
    fansTabContainerInner: {
        display: 'flex',
        flexDirection: 'row',
        gap: 16,
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: Sty.border,
    },
    fansTabContainerInner_mobile: {
        flexDirection: 'column-reverse',
        gap: 0,
        alignItems: 'flex-end',
    },
    cardMetricsContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: 16,
        width: '100%',
    },
    cardMetricsContainer_mobile: {
        flexDirection: 'column',
    },
    noCampaignsContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        padding: 24,
        borderRadius: 16,
        marginTop: 24,
        backgroundColor: Colors.purpleLightest,
    },
    fansTabButtonsContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: 24,
    },
    fansTabButtonsContainer_mobile: {
        flexDirection: 'column',
        gap: 8,
    },
    searchFansModalSubHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
    }
}

export default Fans;